import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSquareBehindSquare2"><Path fillRule="evenodd" clipRule="evenodd" d="M22 3.25C22 2.55964 21.4404 2 20.75 2H9.25C8.55964 2 8 2.55964 8 3.25V8H3.25C2.55964 8 2 8.55964 2 9.25V20.75C2 21.4404 2.55964 22 3.25 22H14.75C15.4404 22 16 21.4404 16 20.75V16H20.75C21.4404 16 22 15.4404 22 14.75V3.25ZM16 14.5H20.5V3.5H9.5V8H14.75C15.4404 8 16 8.55964 16 9.25V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare2;
